<template>
  <BLayoutExpansion title="Текущие сессии">
    <v-list dense style="margin: -8px -16px;">
      <template v-for="(item, index) in list">
        <v-divider v-if="index" :key="`${index}-divider`" />

        <UsersSessionListItem
          :key="item.id"
          :data="item"
          @logout-session="$listeners['logout-session']"
        />
      </template>

      <div
        v-if="!list.length"
        class="text-caption px-4 grey--text"
        v-text="'Нет активных сессий'"
      />
    </v-list>
  </BLayoutExpansion>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import UsersSessionListItem from './UsersSessionListItem.vue'


export default {
  name: 'UsersSessionList',
  components: {
    BLayoutExpansion,
    UsersSessionListItem,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
}
</script>
